import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { useState, useEffect } from 'react'
import HomeMidContent from '../pages/HomeMidContent';
import HomeLastContent from '../pages/HomeLastContent'
import { Plans } from "./ProtectionPlans"; // Import Plans from ProtectionPlans.jsx


function Home() {
    const [isLoading, setIsLoading] = useState(true);

    // Toggle the visibility of the options
    
    const displayedPlans = Plans.filter(plan =>

        ['Start-Up & Business Growth', 'Manage Your Credit', 'Life, Health, & Annuity Insurance', 'Real Estate & Mortgage Consulting Services'].includes(plan.title)

    );

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000);
    }, [])

    // New function to get service link
    const getServiceLink = (title) => {
        switch (title) {
            case 'Manage Your Credit':
                return '/manage-your-credit';
            case 'Life, Health, & Annuity Insurance':
                return '/life-health-annuity-insurance';
            case 'Start-Up & Business Growth':
                return '/startup-business-growth';
            case 'Real Estate & Mortgage Consulting Services':
                return '/real-estate-mortgage-consulting';
            default:
                return '/';
        }
    }

    return (
        <div className="boxed_wrapper ltr">
            {isLoading && <div className="loader-wrap">
                <div className="preloader">
                    <div className="preloader-close">close</div>
                    <div id="handle-preloader" className="handle-preloader">
                        <div className="animation-preloader">
                            {/* <div className="spinner"></div> */}
                            <div className="txt-loading">
                                <img src="assets/images/animation_logo.gif" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <div><div className="xs-sidebar-group info-group info-sidebar">
                <div className="xs-overlay xs-bg-black"></div>
                <div className="xs-overlay xs-overlay-2 xs-bg-black"></div>
                <div className="xs-overlay xs-overlay-3 xs-bg-black"></div>
                <div className="xs-overlay xs-overlay-4 xs-bg-black"></div>
                <div className="xs-overlay xs-overlay-5 xs-bg-black"></div>
                <div className="xs-sidebar-widget">
                    <div className="sidebar-widget-container">
                        <div className="widget-heading">
                            <a href="#" className="close-side-widget">X</a>
                        </div>
                        <div className="sidebar-textwidget">
                            <div className="sidebar-info-contents">
                                <div className="content-inner">
                                    <div className="logo">

                                        <Link to='/'><img src="assets/images/logo-2.png" alt="img" /></Link>
                                    </div>
                                    <div className="text">
                                        <h3>Expert Solutions in Business Funding, Personal Loans, and Credit Restoration</h3>
                                    </div>
                                    <div className="info-box">
                                        <h3>Contact Us</h3>
                                        <ul className="info clearfix">
                                            <li><div className="icon"><img src="assets/images/icons/icon-2.png" alt="img" /></div>9050 Pines Blvd, SUITE 450-3, Pembroke Pines, FL 33024</li>
                                            <li><div className="icon"><img src="assets/images/icons/icon-3.png" alt="img" /></div><a href="mailto:contact@ravlinecorp.com">contact@ravlinecorp.com</a></li>
                                            <li><div className="icon"><img src="assets/images/icons/icon-4.png" alt="img" /></div><a href="tel:(305) 970-7421">(305) 970-7421</a></li>
                                            {/* <li><div className="icon"><img src="assets/images/icons/icon-5.png" alt="img"></div>Working Hrs : 9.30am to 6.30pm</li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                {/* END sidebar widget item */}

                <Header />

                {/* banner-section */}
                <section className="banner-section p_relative">
                    <div className="bg-layer">
                        <video
                            className="lazy-bg"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster="assets/images/banner/banner-1.jpg"
                        >
                            <source src="assets/images/banner/home_banner_video.mp4" type="video/mp4" />
                        </video>

                    </div>
                    {/* <div className="pattern-layer" style="background-image: url(assets/images/shape/shape-1.png);"></div> */}
                    {/* <div className="image-layer">
                <figure className="image-1"><img src="assets/images/banner/banner-img-1.png" alt="img"></figure>
                <figure className="image-2"><img src="assets/images/banner/banner-img-2.png" alt="img"></figure>
            </div> */}
                    {/*<div className="line-grid-wrap">*/}
                    {/*    <span className="line-grid-1"></span>*/}
                    {/*    <span className="line-grid-2"></span>*/}
                    {/*    <span className="line-grid-3"></span>*/}
                    {/*    <span className="line-grid-4"></span>*/}
                    {/*    <span className="line-grid-5"></span>*/}
                    {/*</div>*/}
                    <div className="outer-container clearfix">
                        <div className="content-box text-center">
                            <span className="upper-text wow fadeInUp" data-wow-delay="300ms">EMPOWERING YOUR FUTURE WITH FINANCIAL
                            </span>
                            <h2 className="wow fadeInUp" data-wow-delay="600ms">Solu
                                <span>tions</span></h2>
                            {/*<p className="wow fadeInUp" data-wow-delay="900ms">Expert Solutions in Business Funding, Personal Loans, and Credit Restoration</p>*/}
                            <Link to="/appointment" className="theme-btn btn-one">Schedule your Appointment</Link>
                        </div>
                    </div>
                </section>
                {/* banner-section end */}


                {/* about-section */}
                <HomeMidContent />
                {/* about-section end */}


                <section className="service-section">
                    <div className="auto-container">
                        <div className="sec-title centred">
                            <span className="sub-title mb_16">What we do</span>
                            <h2>Our Solutions, Your Path to Success</h2>
                            <p>
                                We don't just offer services—we become your trusted partner on the journey to financial freedom. Whether you're looking to repair bad credit, build business credit, or establish your business, we're with you every step of the way, empowering you to confidently manage your finances. Our tailored solutions will equip you with the tools and knowledge needed to operate successfully and independently.
                            </p>
                        </div>

                        <div className="inner-container">
                            <div className="row clearfix">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    {displayedPlans.slice(0, 2).map((plan, index) => (
                                        <div
                                            className="service-block wow fadeInUp"
                                            data-wow-delay={`${index * 100}ms`}
                                            key={index}
                                        >
                                            <div className="service-block-one">
                                                <div className="inner-box">
                                                    <div className="icon-box">
                                                        <img src={plan.icon} alt={plan.title} />
                                                    </div>
                                                    <div className="overlay-icon">
                                                        <img src={plan.overlayIcon} alt="Overlay Icon" />
                                                    </div>
                                                    <h3>
                                                        <Link
                                                            to={getServiceLink(plan.title)}
                                                        >
                                                            {plan.title}
                                                        </Link>
                                                    </h3>
                                                    <div className="overlay-link">
                                                        <Link
                                                            to={getServiceLink(plan.title)}
                                                            className="theme-btn btn-one"
                                                        >
                                                            <img src="assets/images/icons/icon-15.png" alt="Link Icon" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    {displayedPlans.slice(2, 4).map((plan, index) => (
                                        <div
                                            className="service-block wow fadeInUp"
                                            data-wow-delay={`${(index + 2) * 100}ms`}
                                            key={index}
                                        >
                                            <div className="service-block-one">
                                                <div className="inner-box">
                                                    <div className="icon-box">
                                                        <img src={plan.icon} alt={plan.title} />
                                                    </div>
                                                    <div className="overlay-icon">
                                                        <img src={plan.overlayIcon} alt="Overlay Icon" />
                                                    </div>
                                                    <h3>
                                                        <Link
                                                            to={getServiceLink(plan.title)}
                                                        >
                                                            {plan.title}
                                                        </Link>
                                                    </h3>
                                                    <div className="overlay-link">
                                                        <Link
                                                            to={getServiceLink(plan.title)}
                                                            className="theme-btn btn-one"
                                                        >
                                                            <img src="assets/images/icons/icon-15.png" alt="Link Icon" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                {/* chooseus-section */}
                <HomeLastContent />
                {/* chooseus-section end */}

                {/* map-section */}
                <section className="map-section">
                    <div className="map-inner">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.799868245698!2d-80.2677719250315!3d26.007372498410973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9a8b00435f4c5%3A0xfc93002f0c8aa4a6!2s9050%20Pines%20Blvd%20450%203%2C%20Pembroke%20Pines%2C%20FL%2033025%2C%20USA!5e0!3m2!1sen!2sin!4v1727686369948!5m2!1sen!2sin"
                            width="600"
                            height="535"
                            frameBorder="0"
                            style={{ border: 0, width: '100%' }}
                            allowFullScreen=""
                            aria-hidden="false"
                            tabIndex="0"
                        ></iframe>
                    </div>

                    <div className="address-box">
                        <h4>Office Address</h4>
                        <p>9050 Pines Blvd<br />SUITE 450-3<br />Pembroke Pines, FL 33024</p>
                        <p>Phone: <a href="tel:(305) 970-7421">(305) 970-7421</a></p>
                        <p>Email: <a href="mailto:contact@ravlinecorp.com">contact@ravlinecorp.com</a></p>
                    </div>
                </section>
                {/* map-section end */}




                <Footer />
                {/* main-footer end */}



                {/*Scroll to top*/}
                <div className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>
                    <div>
                        <div className="scroll-top-inner">
                            <div className="scroll-bar">
                                <div className="bar-inner"></div>
                            </div>
                            <div className="scroll-bar-text">Go To Top</div>
                        </div>
                    </div>
                </div></div>


            {/* Scroll to top end */}

        </div>
    )
}

    export default Home;
